module.exports = __webpack_public_path__ + "img/user-card2.2bac9627.png";